import { useMemo } from 'react'

import type { StepperProps } from './stepperTypes'

import { styled, useStyleConfig, vui } from '../core'
import { cs, filterUndefined } from '../utils'
import { CLASS } from './stepperConsts'
import { StepperProvider } from './stepperContext'

const StepperHorizontalBase = styled.divBox`
  display: flex;
  overflow: hidden;
  width: 100%;

  .${CLASS.step}:last-of-type .${CLASS.tail} {
    display: none;
  }
`

const StepperVerticalBase = styled.divBox`
  width: 100%;

  .${CLASS.step}:last-of-type > .${CLASS.tail} {
    display: none;
  }
`

export const Stepper = vui<'div', StepperProps>((props, ref) => {
  const { children, className, orientation = 'horizontal', size, ...rest } = props
  const context = useMemo(() => filterUndefined({ orientation, size }), [orientation, size])

  const Base = orientation === 'vertical' ? StepperVerticalBase : StepperHorizontalBase

  return (
    <StepperProvider value={context}>
      <Base className={cs('vui-stepper', className)} ref={ref} {...rest}>
        {children}
      </Base>
    </StepperProvider>
  )
})

Stepper.displayName = 'Stepper'

export default Stepper
